export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-100/50 to-accent-100/30 rounded-xl p-8 md:p-12">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
              移动端韩漫阅读入口
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-4 max-w-lg">
              随时随地畅享韩漫阅读体验。支持手机、平板多端访问，流畅浏览全网热门韩漫平台，追更不中断。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-apple-line"></i> iOS 支持
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-android-line"></i> 安卓支持
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-global-line"></i> 网页直达
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}